import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { LOCATION_CHANGE } from 'app/history';
import leaveBookTrip from './leaveBookTrip';

export default function* watchLeaveBookTrip() {
  yield call(takeLatest, LOCATION_CHANGE, leaveBookTrip);
}
